/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Starting_StatusInputs */



/**
* | output |
* | --- |
* | "Starting shot change detection..." |
*
* @param {Scene_Change_Detection_Starting_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_starting_status = /** @type {((inputs?: Scene_Change_Detection_Starting_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Starting_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de la detection de changement de plan...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erkennung von Änderungen beim Startschuss...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio del rilevamento del cambio di inquadratura...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение изменения начального удара...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detección de cambio de disparo inicial...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始投篮变化检测……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット変更検出を開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन का प्रारंभिक पता लगाना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detecção de mudança de tiro inicial...")
	return /** @type {LocalizedString} */ ("Starting shot change detection...")
});